// test2930
(2930 && 0);
